import { RiskLevels } from '@modules/games/KenoGame/api/useKenoPaytable';
import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

const NAME = 'paytables';

export type ValueType = RiskLevels;

const initialState: ValueType = {};

const setAction: ReduxToolkit.CaseReducer<
	ValueType,
	ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
	return action.payload;
};

export const paytablesSlice = createSlice({
	name: NAME,
	initialState,
	reducers: {
		paytablesUpdate: setAction,
	},
});
